<form [formGroup]="form">
  <section class="row">
    <label class="col-6">{{''|i18n:'calculated-rate'}}</label>
    <section class="col-6">
      <div class="row">
        <span>EUR&nbsp;&nbsp;</span><span>{{decimalUtil.enforceDecimals(calculatedRate)}}</span>
      </div>
    </section>
  </section>
  <section class="row" style="align-content: space-between">
    <label class="col-6">{{''| i18n:'penalty-discount-on-warranty-rate'}}</label>
    <section class="col-6">
      <div class="row"><span>EUR&nbsp;&nbsp;</span><input (blur)="emit()" maxlength="4" type="number"
    formControlName="penaltyOrDiscount"></div>
    @if (!form.valid) {
      <app-error-field [errorMessage]="''|i18n:'please-enter-a-valid-amount'"></app-error-field>
    }
  </section>
</section>
<section class="row">
  <label class="col-6"><strong>{{''|i18n:'amount-to-be-charged'}}</strong></label>
  <section class="col-6">
    <div class="row">
      <strong>EUR&nbsp;&nbsp;{{decimalUtil.enforceDecimals(calculateAmountToBeCharged())}} </strong>
      @if (calculateAmountToBeCharged() !==0 && calculateAmountToBeCharged() <= minimumFee ) {
        <span class="ml-1">
          ( Minimum Fee EUR {{decimalUtil.enforceDecimals(minimumFee)}} )
        </span>
      }
    </div>
  </section>
</section>
</form>
